import foulAssistTabContent from './foulAssistTabContent';

export default foulAssistTabContent;